import { render, staticRenderFns } from "./returnOrderWarning.vue?vue&type=template&id=bd88cda0&scoped=true"
import script from "./returnOrderWarning.vue?vue&type=script&lang=js"
export * from "./returnOrderWarning.vue?vue&type=script&lang=js"
import style0 from "./returnOrderWarning.vue?vue&type=style&index=0&id=bd88cda0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd88cda0",
  null
  
)

export default component.exports